import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";
import SEO from "@/components/public/SEO";
import ArticleCard from "@/components/public/ArticleCard";

export default function JournalListPage({ type = "journal", title = "Journal", overline = "Kapadokya hikâyeleri", description = "" }) {
  const [params, setParams] = useSearchParams();
  const [items, setItems] = useState([]);
  const [cats, setCats] = useState([]);
  const [loading, setLoading] = useState(true);
  const activeCat = params.get("kategori") || "";

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const url = `/articles?lang=tr&type=${type}&page_size=24${activeCat ? `&category=${activeCat}` : ""}`;
        const { data } = await api.get(url);
        setItems(data.items || []);
      } finally { setLoading(false); }
    })();
  }, [type, activeCat]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get(`/categories?type=${type}`);
        setCats(data || []);
      } catch {}
    })();
  }, [type]);

  return (
    <>
      <SEO title={title} description={description || `Capella Cave ${title} — Kapadokya editör seçkisi.`} />
      <section className="pt-40 pb-16 max-w-7xl mx-auto px-6 md:px-10" data-testid={`${type}-list-header`}>
        <div className="text-[11px] tracking-overline uppercase text-cc-sepia mb-5">{overline}</div>
        <h1 className="font-serif text-5xl md:text-7xl text-cc-text leading-none mb-8">{title}</h1>
        {description && <p className="max-w-2xl text-cc-muted text-lg leading-relaxed">{description}</p>}

        {cats.length > 0 && (
          <div className="mt-12 flex flex-wrap items-center gap-x-8 gap-y-3 border-t border-cc-border pt-6" data-testid="category-filter">
            <button
              onClick={() => setParams({})}
              className={`text-xs tracking-overline uppercase transition ${!activeCat ? "text-cc-sepia" : "text-cc-muted hover:text-cc-text"}`}
              data-testid="cat-all"
            >
              Tümü
            </button>
            {cats.map((c) => {
              const slug = c.translations?.tr?.slug;
              const name = c.translations?.tr?.name;
              return (
                <button
                  key={c.id}
                  onClick={() => setParams({ kategori: slug })}
                  className={`text-xs tracking-overline uppercase transition ${activeCat === slug ? "text-cc-sepia" : "text-cc-muted hover:text-cc-text"}`}
                  data-testid={`cat-${slug}`}
                >
                  {name}
                </button>
              );
            })}
          </div>
        )}
      </section>

      <section className="pb-32 max-w-7xl mx-auto px-6 md:px-10" data-testid={`${type}-list-grid`}>
        {loading ? (
          <p className="text-cc-muted text-sm">Yükleniyor…</p>
        ) : items.length === 0 ? (
          <p className="text-cc-muted">Bu kategoride henüz yazı yok.</p>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-20">
            {items.map((a, i) => <ArticleCard key={a.id} article={a} index={i} />)}
          </div>
        )}
      </section>
    </>
  );
}
